import {
  ELE_SOLICITAR_START,
  ELE_GETLISTADO_START,
  ELE_RECIBIR_START,
} from "../../const/actionTypes";

export const GetElementos = (payload) => ({
  type: ELE_GETLISTADO_START,
  payload,
});
export const Solicitar = (payload) => ({
  type: ELE_SOLICITAR_START,
  payload,
});
export const Recibir = (payload) => ({
  type: ELE_RECIBIR_START,
  payload,
});
